import { IoIosCheckmarkCircle } from "react-icons/io";
import React from "react";

export default function SuccessFormCard({closeModalAction, message, buttonMessage} : {closeModalAction: () => void, message: string, buttonMessage: string}) {
  return (
    <>
      <div className="relative mb-10 flex w-full flex-col items-center gap-5 rounded-[36px] bg-[#4CAF5014] p-16">
        <span className="h1 text-success-primary">
          <IoIosCheckmarkCircle />
        </span>
        <h2 className="h3 mx-auto text-success-primary">Hotovo</h2>
        <p>{message}</p>
      </div>
      <p className="flex justify-center w-full">
        <button
          onClick={() => closeModalAction()}
          className="btn btn-primary ripple hover:cursor-pointer"
        >
          {buttonMessage}
        </button>
      </p>
    </>
  );
}
